import React from 'react';
import Icon from '../../../components/AppIcon';

const JwtMetadataPanel = ({ data, loading }) => {
  const getRoleBadgeColor = (role) => {
    if (role === 'admin') return 'bg-primary/10 text-primary border-primary/20';
    return 'bg-muted text-muted-foreground border-border';
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-md">
      <div className="p-4 md:p-6 border-b border-border">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-success/10">
            <Icon name="Key" size={20} color="var(--color-success)" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">JWT Token Metadata</h3>
            <p className="text-xs text-muted-foreground">Decoded token payload and claims</p>
          </div>
        </div>
      </div>
      <div className="p-4 md:p-6">
        {loading ? (
          <div className="flex items-center justify-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
          </div>
        ) : data ? (
          <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-1">
                <label className="text-xs font-medium text-muted-foreground">Role Claim</label>
                <div className="flex items-center gap-2">
                  <span className={`inline-flex items-center px-3 py-1.5 rounded-md text-sm font-medium border ${getRoleBadgeColor(data?.role)}`}>
                    {data?.role || 'Not set'}
                  </span>
                </div>
              </div>
              <div className="space-y-1">
                <label className="text-xs font-medium text-muted-foreground">Full Name</label>
                <p className="text-sm text-foreground bg-muted p-2 rounded">{data?.full_name || 'N/A'}</p>
              </div>
              <div className="space-y-1">
                <label className="text-xs font-medium text-muted-foreground">Email</label>
                <p className="text-sm text-foreground bg-muted p-2 rounded">{data?.email}</p>
              </div>
              <div className="space-y-1">
                <label className="text-xs font-medium text-muted-foreground">Audience (aud)</label>
                <p className="text-sm text-foreground bg-muted p-2 rounded">{data?.aud || 'N/A'}</p>
              </div>
              <div className="space-y-1 md:col-span-2">
                <label className="text-xs font-medium text-muted-foreground">Confirmed At</label>
                <p className="text-sm text-foreground bg-muted p-2 rounded">
                  {data?.confirmed_at ? new Date(data.confirmed_at)?.toLocaleString() : 'N/A'}
                </p>
              </div>
            </div>

            <div className="space-y-2 mt-4">
              <label className="text-xs font-medium text-muted-foreground">App Metadata Claims</label>
              <pre className="text-xs font-mono text-foreground bg-muted p-3 rounded overflow-x-auto max-h-40 overflow-y-auto">
                {JSON.stringify(data?.claims, null, 2)}
              </pre>
            </div>

            <div className="flex items-start gap-2 p-3 bg-primary/5 border border-primary/20 rounded-lg mt-4">
              <Icon name="Info" size={16} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
              <div className="text-xs text-foreground">
                <p className="font-medium mb-1">JWT Token Information</p>
                <p className="text-muted-foreground">This data is extracted from the user's authentication token and represents the claims available during the current session.</p>
              </div>
            </div>
          </div>
        ) : (
          <div className="text-center py-8 text-muted-foreground">
            <Icon name="AlertCircle" size={32} className="mx-auto mb-2 opacity-50" />
            <p>No JWT metadata available</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default JwtMetadataPanel;